import { useEffect, useState } from "react";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../util/firebase";
import { query, collection, getDocs, where } from "firebase/firestore";

import { useNavigate } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";
import { FaChevronLeft } from "react-icons/fa";
import { useTranslation } from "react-i18next";

function WalletHistoryPage() {
  const { t } = useTranslation("common");
  const [user] = useAuthState(auth);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [walletTransactions, setWalletTransactions] = useState([]);

  const fetchWalletTransactions = async () => {
    try {
      setIsLoading(true);
      const q = query(
        collection(db, "wallet_transactions"),
        where("userUid", "==", user?.uid)
      );
      const docs = await getDocs(q);
      let txs = docs.docs.map((d) => ({ id: d.id, ...d.data() }));
      txs = txs.sort((a, b) => {
        const ta =
          a.timestamp && a.timestamp.toDate
            ? a.timestamp.toDate().getTime()
            : a.timestamp
            ? new Date(a.timestamp).getTime()
            : 0;
        const tb =
          b.timestamp && b.timestamp.toDate
            ? b.timestamp.toDate().getTime()
            : b.timestamp
            ? new Date(b.timestamp).getTime()
            : 0;
        return tb - ta;
      });
      setWalletTransactions(txs);
      setIsLoading(false);
    } catch (err) {
      console.error("Failed to fetch wallet transactions:", err);
      alert("An error occured while fetching wallet transactions");
      setWalletTransactions([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user) fetchWalletTransactions();
    // eslint-disable-next-line
  }, [user]);

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="walletHistoryPage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        {t("walletHistory").toUpperCase()}
      </h1>

      <div style={{ marginTop: "1rem" }}>
        {walletTransactions && walletTransactions.length > 0 ? (
          <div className="walletTransactionsList">
            {walletTransactions.map((tx) => (
              <div key={tx.id} className="tx">
                <div className="left">
                  <span style={{ color: "#FFFFFF", fontWeight: 600 }}>
                    {new Date(
                      tx.timestamp?.toDate
                        ? tx.timestamp.toDate()
                        : tx.timestamp
                    ).toLocaleString()}
                  </span>
                  <span style={{ color: "#9aa3bf", fontSize: 13 }}>
                    {tx.reason || tx.type || "transaction"}
                    {tx.tournamentUid ? ` · ${tx.tournamentUid}` : ""}
                  </span>
                </div>
                <div className="right">
                  <div
                    style={{
                      color: tx.change >= 0 ? "#4BE37F" : "#FF6B6B",
                      fontWeight: 700,
                    }}
                  >
                    {tx.change >= 0 ? `+${tx.change}` : tx.change} {tx.currency}
                  </div>
                  <div style={{ color: "#9aa3bf", fontSize: 13 }}>
                    {typeof tx.previousBalance !== "undefined" &&
                    typeof tx.newBalance !== "undefined"
                      ? `${tx.previousBalance} → ${tx.newBalance}`
                      : null}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="walletTransactionsEmpty">
            {t("youHaveNoWalletTransactions")}
          </p>
        )}
      </div>
    </div>
  );
}

export default WalletHistoryPage;
